import { render, staticRenderFns } from "./GetDetails.vue?vue&type=template&id=6b66744a&"
import script from "./GetDetails.vue?vue&type=script&lang=js&"
export * from "./GetDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports